var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.$t("Price.AirCargoRateDetails"),
        width: _vm.dialogWidth,
        "close-on-click-modal": false,
        "destroy-on-close": true,
        top: "5vh",
        "custom-class": "details-view air-form"
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c("div", { staticClass: "main-content" }, [
        _c(
          "div",
          { staticStyle: { "margin-bottom": "10px" } },
          [
            _c(
              "el-button",
              {
                attrs: { no: "onSubmit", type: "primary" },
                on: { click: _vm.onSubmit }
              },
              [_vm._v(_vm._s(_vm.$t("Pricing.Save")))]
            ),
            _c(
              "el-button",
              { attrs: { no: "onCancel" }, on: { click: _vm.onCancel } },
              [_vm._v(_vm._s(_vm.$t("Pricing.Cancel")))]
            )
          ],
          1
        ),
        _c("div", { staticStyle: { width: "fit-content" } }, [
          _c("div", { staticStyle: { display: "flex" } }, [
            _c(
              "div",
              { staticClass: "section form-column" },
              [
                _c(
                  "el-form",
                  {
                    attrs: { "label-width": "75px", "label-position": "left" }
                  },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Pricing.Level") } },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: { no: "airLevel", disabled: !_vm.isNew },
                            model: {
                              value: _vm.airLevel,
                              callback: function($$v) {
                                _vm.airLevel = $$v
                              },
                              expression: "airLevel"
                            }
                          },
                          _vm._l(_vm.tiers, function(item, index) {
                            return _c("el-option", {
                              key: index,
                              attrs: { label: item.label, value: item.value }
                            })
                          }),
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        ref: "pol",
                        attrs: { required: "", label: _vm.$t("Pricing.Origin") }
                      },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "pol",
                            "select-type":
                              _vm.selectTypeNames.basic_data_Airport,
                            "custom-label": function(item) {
                              return "[" + item.code + "]" + item.englishName
                            },
                            "filter-tag-names": ["code", "englishName"],
                            "default-value": _vm.priceAir.pol,
                            filterable: ""
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.priceAir.pol = p.code
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        ref: "pod",
                        attrs: { required: "", label: _vm.$t("Pricing.Dest") }
                      },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "pod",
                            "select-type":
                              _vm.selectTypeNames.basic_data_Airport,
                            "custom-label": function(item) {
                              return "[" + item.code + "]" + item.englishName
                            },
                            "filter-tag-names": ["code", "englishName"],
                            "show-custom-label-in-option": true,
                            "default-value": _vm.priceAir.pod,
                            filterable: ""
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.priceAir.pod = p.code
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: " " } },
                      [
                        _c("el-checkbox", {
                          attrs: {
                            no: "isDirect",
                            label: _vm.$t("Pricing.Direct")
                          },
                          model: {
                            value: _vm.isDirect,
                            callback: function($$v) {
                              _vm.isDirect = $$v
                            },
                            expression: "isDirect"
                          }
                        })
                      ],
                      1
                    ),
                    !_vm.isDirect
                      ? _c(
                          "el-form-item",
                          {
                            ref: "via",
                            attrs: {
                              required: true,
                              label: _vm.$t("Pricing.TSport")
                            }
                          },
                          [
                            _c("cargo-advance-select", {
                              attrs: {
                                no: "via",
                                "select-type":
                                  _vm.selectTypeNames.basic_data_Airport,
                                "custom-label": function(item) {
                                  return (
                                    "[" + item.code + "]" + item.englishName
                                  )
                                },
                                "filter-tag-names": ["code", "englishName"],
                                "show-custom-label-in-option": true,
                                "default-value": _vm.priceAir.via,
                                filterable: ""
                              },
                              on: {
                                parentCallBack: function(p) {
                                  _vm.priceAir.via = p.code
                                }
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    !_vm.isDirect
                      ? _c(
                          "el-form-item",
                          { attrs: { label: _vm.$t("Price.SecondTransit") } },
                          [
                            _c("cargo-advance-select", {
                              attrs: {
                                no: "via2",
                                "select-type":
                                  _vm.selectTypeNames.basic_data_Airport,
                                "custom-label": function(item) {
                                  return (
                                    "[" + item.code + "]" + item.englishName
                                  )
                                },
                                "filter-tag-names": ["code", "englishName"],
                                "show-custom-label-in-option": true,
                                "default-value": _vm.priceAir.via2,
                                filterable: ""
                              },
                              on: {
                                parentCallBack: function(p) {
                                  _vm.priceAir.via2 = p.code
                                }
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Pricing.Flight") } },
                      [
                        _c(
                          "el-tooltip",
                          {
                            staticClass: "item",
                            attrs: {
                              effect: "dark",
                              content: _vm.serviceItem.toString(),
                              placement: "top-end"
                            }
                          },
                          [
                            _c("cargo-advance-select", {
                              attrs: {
                                no: "flight",
                                filterable: "",
                                multiple: "",
                                "select-type":
                                  _vm.selectTypeNames
                                    .basic_data_PriceServiceAir,
                                "custom-label": function(item) {
                                  return (
                                    "[" + item.code + "]" + item.chineseName
                                  )
                                },
                                "show-custom-label-in-option": true,
                                "default-multiple-value": _vm.serviceItem
                              },
                              on: {
                                parentCallBack: function(p) {
                                  _vm.serviceItem = p.value
                                }
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        ref: "flightNo",
                        attrs: { label: _vm.$t("Pricing.FlightNo") }
                      },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "flightNo",
                            filterable: "",
                            multiple: "",
                            "tag-name": "flightNo",
                            "tag-value": "uuid",
                            "static-options": _vm.flightNoOption,
                            "filter-tag-names": ["flightNo"],
                            "show-custom-label-in-option": true,
                            "default-multiple-value": _vm.priceAir.flightNoUuid
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.priceAir.flightNoUuid = p.value
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        ref: "aircraft",
                        attrs: {
                          required: "",
                          label: _vm.$t("Pricing.Aircraft")
                        }
                      },
                      [
                        _c("el-input", {
                          attrs: { no: "aircraft", maxlength: 64 },
                          model: {
                            value: _vm.aircraft,
                            callback: function($$v) {
                              _vm.aircraft = $$v
                            },
                            expression: "aircraft"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: { label: _vm.$t("Price.SecondLegAircraftType") }
                      },
                      [
                        _c("el-input", {
                          attrs: { no: "secondAircraft", maxlength: 64 },
                          model: {
                            value: _vm.secondAircraft,
                            callback: function($$v) {
                              _vm.secondAircraft = $$v
                            },
                            expression: "secondAircraft"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Pricing.Currency") } },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "currency",
                            "select-type":
                              _vm.selectTypeNames.basic_data_Currency,
                            filterable: "",
                            clearable: false,
                            "default-value": _vm.priceAir.currency
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.priceAir.currency = p.value
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Pricing.weightVolume") } },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "weightVolume",
                            "select-type":
                              _vm.selectTypeNames
                                .local_cache_PriceConstant$WEIGHT_VOLUMES,
                            filterable: "",
                            clearable: true,
                            "default-value": _vm.priceAir.weightVolume
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.priceAir.weightVolume = p.value
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Pricing.priceNature") } },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "priceNature",
                            "select-type":
                              _vm.selectTypeNames
                                .local_cache_PriceConstant$PRICE_NATURE,
                            "show-custom-label-in-option": true,
                            "default-value": _vm.priceAir.priceNature
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.priceAir.priceNature = p.value
                            }
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "section form-column" },
              [
                _c(
                  "el-form",
                  {
                    attrs: { "label-width": "75px", "label-position": "left" }
                  },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Pricing.MinCharge") } },
                      [
                        _c("price-air-numeric-stepper", {
                          attrs: { no: "minCharge", "show-tact": true },
                          model: {
                            value: _vm.priceAir.minCharge,
                            callback: function($$v) {
                              _vm.$set(_vm.priceAir, "minCharge", $$v)
                            },
                            expression: "priceAir.minCharge"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Pricing.NStep") } },
                      [
                        _c("price-air-numeric-stepper", {
                          attrs: { no: "step", "show-tact": true },
                          model: {
                            value: _vm.priceAir.step,
                            callback: function($$v) {
                              _vm.$set(_vm.priceAir, "step", $$v)
                            },
                            expression: "priceAir.step"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "+45" } },
                      [
                        _c("price-air-numeric-stepper", {
                          attrs: { no: "p45", "show-tact": true },
                          model: {
                            value: _vm.priceAir.p45,
                            callback: function($$v) {
                              _vm.$set(_vm.priceAir, "p45", $$v)
                            },
                            expression: "priceAir.p45"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "+100" } },
                      [
                        _c("price-air-numeric-stepper", {
                          attrs: { no: "p100", "show-tact": true },
                          model: {
                            value: _vm.priceAir.p100,
                            callback: function($$v) {
                              _vm.$set(_vm.priceAir, "p100", $$v)
                            },
                            expression: "priceAir.p100"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "+300" } },
                      [
                        _c("price-air-numeric-stepper", {
                          attrs: { no: "p300", "show-tact": true },
                          model: {
                            value: _vm.priceAir.p300,
                            callback: function($$v) {
                              _vm.$set(_vm.priceAir, "p300", $$v)
                            },
                            expression: "priceAir.p300"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "+500" } },
                      [
                        _c("price-air-numeric-stepper", {
                          attrs: { no: "p500" },
                          model: {
                            value: _vm.priceAir.p500,
                            callback: function($$v) {
                              _vm.$set(_vm.priceAir, "p500", $$v)
                            },
                            expression: "priceAir.p500"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "+1000" } },
                      [
                        _c("price-air-numeric-stepper", {
                          attrs: { no: "p1000" },
                          model: {
                            value: _vm.priceAir.p1000,
                            callback: function($$v) {
                              _vm.$set(_vm.priceAir, "p1000", $$v)
                            },
                            expression: "priceAir.p1000"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "section form-column" },
              [
                _c(
                  "el-form",
                  {
                    attrs: { "label-width": "90px", "label-position": "left" }
                  },
                  [
                    _c(
                      "el-form-item",
                      {
                        ref: "carrier",
                        attrs: {
                          required: "",
                          label: _vm.$t("Pricing.Carrier_Air")
                        }
                      },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "carrier",
                            filterable: "",
                            "select-type":
                              _vm.selectTypeNames.basic_data_Company,
                            "method-params": { airCmp: true },
                            "default-value": _vm.priceAir.carrier
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.priceAir.carrier = p.cmpIdx
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        ref: "bookingAgent",
                        attrs: { required: "", label: _vm.$t("Pricing.Agent") }
                      },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "bookingAgent",
                            filterable: "",
                            "select-type":
                              _vm.selectTypeNames.basic_data_Company,
                            "method-params": { bookingAgent: true },
                            "tag-name": "chineseName",
                            "default-value": _vm.priceAir.bookingAgent
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.priceAir.bookingAgent = p.cmpIdx
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        ref: "isFrequency",
                        attrs: {
                          required: "",
                          label: _vm.$t("Pricing.DepartureDayOfAir")
                        }
                      },
                      [
                        _c("el-input", {
                          attrs: {
                            no: "isFrequency",
                            disabled: true,
                            value: _vm.isFrequency
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "frequency" },
                      [
                        _c("el-checkbox", {
                          attrs: { no: "frequency1", label: 1 },
                          model: {
                            value: _vm.priceAir.frequency1,
                            callback: function($$v) {
                              _vm.$set(_vm.priceAir, "frequency1", $$v)
                            },
                            expression: "priceAir.frequency1"
                          }
                        }),
                        _c("el-checkbox", {
                          attrs: { no: "frequency2", label: 2 },
                          model: {
                            value: _vm.priceAir.frequency2,
                            callback: function($$v) {
                              _vm.$set(_vm.priceAir, "frequency2", $$v)
                            },
                            expression: "priceAir.frequency2"
                          }
                        }),
                        _c("el-checkbox", {
                          attrs: { no: "frequency3", label: 3 },
                          model: {
                            value: _vm.priceAir.frequency3,
                            callback: function($$v) {
                              _vm.$set(_vm.priceAir, "frequency3", $$v)
                            },
                            expression: "priceAir.frequency3"
                          }
                        }),
                        _c("el-checkbox", {
                          attrs: { no: "frequency4", label: 4 },
                          model: {
                            value: _vm.priceAir.frequency4,
                            callback: function($$v) {
                              _vm.$set(_vm.priceAir, "frequency4", $$v)
                            },
                            expression: "priceAir.frequency4"
                          }
                        }),
                        _c("el-checkbox", {
                          attrs: { no: "frequency5", label: 5 },
                          model: {
                            value: _vm.priceAir.frequency5,
                            callback: function($$v) {
                              _vm.$set(_vm.priceAir, "frequency5", $$v)
                            },
                            expression: "priceAir.frequency5"
                          }
                        }),
                        _c("el-checkbox", {
                          attrs: { no: "frequency6", label: 6 },
                          model: {
                            value: _vm.priceAir.frequency6,
                            callback: function($$v) {
                              _vm.$set(_vm.priceAir, "frequency6", $$v)
                            },
                            expression: "priceAir.frequency6"
                          }
                        }),
                        _c("el-checkbox", {
                          attrs: { no: "frequency7", label: 7 },
                          model: {
                            value: _vm.priceAir.frequency7,
                            callback: function($$v) {
                              _vm.$set(_vm.priceAir, "frequency7", $$v)
                            },
                            expression: "priceAir.frequency7"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("Price.SecondLegFlightSchedule")
                        }
                      },
                      [
                        _c("el-input", {
                          attrs: { disabled: true, value: _vm.isFrequency2 }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "frequency" },
                      [
                        _c("el-checkbox", {
                          attrs: { no: "secondFrequency1", label: 1 },
                          model: {
                            value: _vm.priceAir.secondFrequency1,
                            callback: function($$v) {
                              _vm.$set(_vm.priceAir, "secondFrequency1", $$v)
                            },
                            expression: "priceAir.secondFrequency1"
                          }
                        }),
                        _c("el-checkbox", {
                          attrs: { no: "secondFrequency2", label: 2 },
                          model: {
                            value: _vm.priceAir.secondFrequency2,
                            callback: function($$v) {
                              _vm.$set(_vm.priceAir, "secondFrequency2", $$v)
                            },
                            expression: "priceAir.secondFrequency2"
                          }
                        }),
                        _c("el-checkbox", {
                          attrs: { no: "secondFrequency3", label: 3 },
                          model: {
                            value: _vm.priceAir.secondFrequency3,
                            callback: function($$v) {
                              _vm.$set(_vm.priceAir, "secondFrequency3", $$v)
                            },
                            expression: "priceAir.secondFrequency3"
                          }
                        }),
                        _c("el-checkbox", {
                          attrs: { no: "secondFrequency4", label: 4 },
                          model: {
                            value: _vm.priceAir.secondFrequency4,
                            callback: function($$v) {
                              _vm.$set(_vm.priceAir, "secondFrequency4", $$v)
                            },
                            expression: "priceAir.secondFrequency4"
                          }
                        }),
                        _c("el-checkbox", {
                          attrs: { no: "secondFrequency5", label: 5 },
                          model: {
                            value: _vm.priceAir.secondFrequency5,
                            callback: function($$v) {
                              _vm.$set(_vm.priceAir, "secondFrequency5", $$v)
                            },
                            expression: "priceAir.secondFrequency5"
                          }
                        }),
                        _c("el-checkbox", {
                          attrs: { no: "secondFrequency6", label: 6 },
                          model: {
                            value: _vm.priceAir.secondFrequency6,
                            callback: function($$v) {
                              _vm.$set(_vm.priceAir, "secondFrequency6", $$v)
                            },
                            expression: "priceAir.secondFrequency6"
                          }
                        }),
                        _c("el-checkbox", {
                          attrs: { no: "secondFrequency7", label: 7 },
                          model: {
                            value: _vm.priceAir.secondFrequency7,
                            callback: function($$v) {
                              _vm.$set(_vm.priceAir, "secondFrequency7", $$v)
                            },
                            expression: "priceAir.secondFrequency7"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        ref: "days",
                        attrs: { required: "", label: _vm.$t("Pricing.Days") }
                      },
                      [
                        _c("el-input", {
                          attrs: { no: "days", maxlength: 16 },
                          model: {
                            value: _vm.priceAir.days,
                            callback: function($$v) {
                              _vm.$set(_vm.priceAir, "days", $$v)
                            },
                            expression: "priceAir.days"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        ref: "beginDate",
                        attrs: {
                          required: "",
                          label: _vm.$t("Pricing.BeginDate")
                        }
                      },
                      [
                        _c(
                          "div",
                          { staticStyle: { display: "flex" } },
                          [
                            _c("el-date-picker", {
                              staticStyle: { flex: "1" },
                              attrs: {
                                no: "beginDate",
                                type: "date",
                                "value-format": "yyyy-MM-dd",
                                clearable: ""
                              },
                              model: {
                                value: _vm.priceAir.beginDate,
                                callback: function($$v) {
                                  _vm.$set(_vm.priceAir, "beginDate", $$v)
                                },
                                expression: "priceAir.beginDate"
                              }
                            })
                          ],
                          1
                        )
                      ]
                    ),
                    _c(
                      "el-form-item",
                      {
                        ref: "endDate",
                        attrs: {
                          required: "",
                          label: _vm.$t("Pricing.EndDate")
                        }
                      },
                      [
                        _c(
                          "div",
                          { staticStyle: { display: "flex" } },
                          [
                            _c("el-date-picker", {
                              staticStyle: { flex: "1" },
                              attrs: {
                                no: "endDate",
                                type: "date",
                                "value-format": "yyyy-MM-dd",
                                clearable: ""
                              },
                              model: {
                                value: _vm.priceAir.endDate,
                                callback: function($$v) {
                                  _vm.$set(_vm.priceAir, "endDate", $$v)
                                },
                                expression: "priceAir.endDate"
                              }
                            })
                          ],
                          1
                        )
                      ]
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Pricing.Remarks") } },
                      [
                        _c("cargo-rich-textarea", {
                          staticStyle: { "min-height": "80px" },
                          attrs: {
                            no: "remarks",
                            "text-chars": 0,
                            "warning-count": -1
                          },
                          nativeOn: {
                            dblclick: function($event) {
                              _vm.showAdvanceTextDialog(
                                _vm.$t("SeaExport.Remarks"),
                                _vm.priceAir.remarks,
                                function(val) {
                                  _vm.priceAir.remarks = val
                                }
                              )
                            }
                          },
                          model: {
                            value: _vm.priceAir.remarks,
                            callback: function($$v) {
                              _vm.$set(_vm.priceAir, "remarks", $$v)
                            },
                            expression: "priceAir.remarks"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "section form-column" },
              [
                _c(
                  "el-form",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.priceAir.level === 0,
                        expression: "priceAir.level === 0"
                      }
                    ],
                    attrs: { "label-width": "70px", "label-position": "left" }
                  },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "T1Min" } },
                      [
                        _c("price-air-numeric-stepper", {
                          attrs: { no: "T1Min", "show-tact": true },
                          model: {
                            value: _vm.priceAir.t1Min,
                            callback: function($$v) {
                              _vm.$set(_vm.priceAir, "t1Min", $$v)
                            },
                            expression: "priceAir.t1Min"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "T1Step" } },
                      [
                        _c("price-air-numeric-stepper", {
                          attrs: { no: "T1Step", "show-tact": true },
                          model: {
                            value: _vm.priceAir.t1Step,
                            callback: function($$v) {
                              _vm.$set(_vm.priceAir, "t1Step", $$v)
                            },
                            expression: "priceAir.t1Step"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "T1P45" } },
                      [
                        _c("price-air-numeric-stepper", {
                          attrs: { no: "T1P45", "show-tact": true },
                          model: {
                            value: _vm.priceAir.t1P45,
                            callback: function($$v) {
                              _vm.$set(_vm.priceAir, "t1P45", $$v)
                            },
                            expression: "priceAir.t1P45"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "T1P100" } },
                      [
                        _c("price-air-numeric-stepper", {
                          attrs: { no: "T1P100", "show-tact": true },
                          model: {
                            value: _vm.priceAir.t1P100,
                            callback: function($$v) {
                              _vm.$set(_vm.priceAir, "t1P100", $$v)
                            },
                            expression: "priceAir.t1P100"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "T1P300" } },
                      [
                        _c("price-air-numeric-stepper", {
                          attrs: { no: "T1P300", "show-tact": true },
                          model: {
                            value: _vm.priceAir.t1P300,
                            callback: function($$v) {
                              _vm.$set(_vm.priceAir, "t1P300", $$v)
                            },
                            expression: "priceAir.t1P300"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "T1P500" } },
                      [
                        _c("price-air-numeric-stepper", {
                          attrs: { no: "T1P500" },
                          model: {
                            value: _vm.priceAir.t1P500,
                            callback: function($$v) {
                              _vm.$set(_vm.priceAir, "t1P500", $$v)
                            },
                            expression: "priceAir.t1P500"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "T1P1000" } },
                      [
                        _c("price-air-numeric-stepper", {
                          attrs: { no: "T1P1000" },
                          model: {
                            value: _vm.priceAir.t1P1000,
                            callback: function($$v) {
                              _vm.$set(_vm.priceAir, "t1P1000", $$v)
                            },
                            expression: "priceAir.t1P1000"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "T2Min" } },
                      [
                        _c("price-air-numeric-stepper", {
                          attrs: { no: "T2Min", "show-tact": true },
                          model: {
                            value: _vm.priceAir.t2Min,
                            callback: function($$v) {
                              _vm.$set(_vm.priceAir, "t2Min", $$v)
                            },
                            expression: "priceAir.t2Min"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "T2Step" } },
                      [
                        _c("price-air-numeric-stepper", {
                          attrs: { no: "T2Step", "show-tact": true },
                          model: {
                            value: _vm.priceAir.t2Step,
                            callback: function($$v) {
                              _vm.$set(_vm.priceAir, "t2Step", $$v)
                            },
                            expression: "priceAir.t2Step"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "T2P45" } },
                      [
                        _c("price-air-numeric-stepper", {
                          attrs: { no: "T2P45", "show-tact": true },
                          model: {
                            value: _vm.priceAir.t2P45,
                            callback: function($$v) {
                              _vm.$set(_vm.priceAir, "t2P45", $$v)
                            },
                            expression: "priceAir.t2P45"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "T2P100" } },
                      [
                        _c("price-air-numeric-stepper", {
                          attrs: { no: "T2P100", "show-tact": true },
                          model: {
                            value: _vm.priceAir.t2P100,
                            callback: function($$v) {
                              _vm.$set(_vm.priceAir, "t2P100", $$v)
                            },
                            expression: "priceAir.t2P100"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "section form-column" },
              [
                _c(
                  "el-form",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.priceAir.level === 0,
                        expression: "priceAir.level === 0"
                      }
                    ],
                    attrs: { "label-width": "70px", "label-position": "left" }
                  },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "T2P300" } },
                      [
                        _c("price-air-numeric-stepper", {
                          attrs: { no: "t2P300", "show-tact": true },
                          model: {
                            value: _vm.priceAir.t2P300,
                            callback: function($$v) {
                              _vm.$set(_vm.priceAir, "t2P300", $$v)
                            },
                            expression: "priceAir.t2P300"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "T2P500" } },
                      [
                        _c("price-air-numeric-stepper", {
                          attrs: { no: "t2P500" },
                          model: {
                            value: _vm.priceAir.t2P500,
                            callback: function($$v) {
                              _vm.$set(_vm.priceAir, "t2P500", $$v)
                            },
                            expression: "priceAir.t2P500"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "T2P1000" } },
                      [
                        _c("price-air-numeric-stepper", {
                          attrs: { no: "T2P1000" },
                          model: {
                            value: _vm.priceAir.t2P1000,
                            callback: function($$v) {
                              _vm.$set(_vm.priceAir, "t2P1000", $$v)
                            },
                            expression: "priceAir.t2P1000"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "T3Min" } },
                      [
                        _c("price-air-numeric-stepper", {
                          attrs: { no: "t3Min", "show-tact": true },
                          model: {
                            value: _vm.priceAir.t3Min,
                            callback: function($$v) {
                              _vm.$set(_vm.priceAir, "t3Min", $$v)
                            },
                            expression: "priceAir.t3Min"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "T3Step" } },
                      [
                        _c("price-air-numeric-stepper", {
                          attrs: { no: "t3Step", "show-tact": true },
                          model: {
                            value: _vm.priceAir.t3Step,
                            callback: function($$v) {
                              _vm.$set(_vm.priceAir, "t3Step", $$v)
                            },
                            expression: "priceAir.t3Step"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "T3P45" } },
                      [
                        _c("price-air-numeric-stepper", {
                          attrs: { no: "t3P45", "show-tact": true },
                          model: {
                            value: _vm.priceAir.t3P45,
                            callback: function($$v) {
                              _vm.$set(_vm.priceAir, "t3P45", $$v)
                            },
                            expression: "priceAir.t3P45"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "T3P100" } },
                      [
                        _c("price-air-numeric-stepper", {
                          attrs: { no: "t3P100", "show-tact": true },
                          model: {
                            value: _vm.priceAir.t3P100,
                            callback: function($$v) {
                              _vm.$set(_vm.priceAir, "t3P100", $$v)
                            },
                            expression: "priceAir.t3P100"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "T3P300" } },
                      [
                        _c("price-air-numeric-stepper", {
                          attrs: { no: "t3P300", "show-tact": true },
                          model: {
                            value: _vm.priceAir.t3P300,
                            callback: function($$v) {
                              _vm.$set(_vm.priceAir, "t3P300", $$v)
                            },
                            expression: "priceAir.t3P300"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "T3P500" } },
                      [
                        _c("price-air-numeric-stepper", {
                          attrs: { no: "t3P500" },
                          model: {
                            value: _vm.priceAir.t3P500,
                            callback: function($$v) {
                              _vm.$set(_vm.priceAir, "t3P500", $$v)
                            },
                            expression: "priceAir.t3P500"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "T3P1000" } },
                      [
                        _c("price-air-numeric-stepper", {
                          attrs: { no: "t3P1000" },
                          model: {
                            value: _vm.priceAir.t3P1000,
                            callback: function($$v) {
                              _vm.$set(_vm.priceAir, "t3P1000", $$v)
                            },
                            expression: "priceAir.t3P1000"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ])
        ])
      ]),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.advanceTextDialog.visible,
            title: _vm.advanceTextDialog.title,
            width: "600px",
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            "modal-append-to-body": false,
            "append-to-body": true
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.advanceTextDialog, "visible", $event)
            }
          }
        },
        [
          _c("cargo-rich-textarea", {
            ref: "advanceTextDialogTextarea",
            staticStyle: { height: "198px" },
            attrs: {
              no: "advanceTextDialogTextarea",
              required: false,
              "text-chars": _vm.advanceTextDialog.formatObj.maxChar,
              "warning-count": _vm.advanceTextDialog.formatObj.warningCount
            },
            model: {
              value: _vm.advanceTextDialog.value,
              callback: function($$v) {
                _vm.$set(_vm.advanceTextDialog, "value", $$v)
              },
              expression: "advanceTextDialog.value"
            }
          }),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { no: "finishAdvanceText", type: "primary" },
                  on: { click: _vm.finishAdvanceText }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "advanceTextDialogClose" },
                  on: {
                    click: function($event) {
                      _vm.advanceTextDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.close")))]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }